/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Roles_CreatedInputs */

const en_admin_roles_created = /** @type {(inputs: Admin_Roles_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role created`)
};

/**
* | output |
* | --- |
* | "Role created" |
*
* @param {Admin_Roles_CreatedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_roles_created = /** @type {((inputs?: Admin_Roles_CreatedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Roles_CreatedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_roles_created(inputs)
});
export { admin_roles_created as "admin.roles.created" }